// extracted by mini-css-extract-plugin
export default {"sideDrawer__main":"MySearch_sideDrawer__main__BqcDH","sideDrawer__content":"MySearch_sideDrawer__content__363YZ"};